import React from 'react';
import { View } from 'react-native';

import { map as _map } from 'lodash';

import { Shimmer } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import {
  shimmerPlaceholderConfig,
  licencesUsageTitleConfig,
  licenceUsageCardLoadingConfig,
  licenceCardLoadingConfig,
  licencesUsageSubtitleConfig,
  tabsLoadingConfig,
  licencesListTitleConfig,
  searchBarConfig,
} from './LicencesLoading.Config';
import styles from './LicencesLoading.Styles';

function LicencesLoading(props) {
  const theme = useTheme();
  const renderLicencesUsageShimmering = () => {
    return (
      <>
        <Shimmer
          config={licencesUsageTitleConfig}
          shimmerPlaceholderConfig={shimmerPlaceholderConfig}
        />
        <Shimmer
          config={licencesUsageSubtitleConfig}
          shimmerPlaceholderConfig={shimmerPlaceholderConfig}
        />
        <View style={[styles.licenceCardStyle(theme), styles.cardStyle(theme)]}>
          <Shimmer
            config={licenceUsageCardLoadingConfig}
            shimmerPlaceholderConfig={shimmerPlaceholderConfig}
          />
        </View>
      </>
    );
  };

  const renderFilterBarShimmering = () => {
    return (
      <View style={styles.tabsContainerStyle}>
        <Shimmer config={tabsLoadingConfig} shimmerPlaceholderConfig={shimmerPlaceholderConfig} />
      </View>
    );
  };

  const renderLicenceCard = key => {
    return (
      <View style={[styles.licenceCardStyle(theme), styles.cardStyle(theme)]} key={key}>
        <Shimmer
          config={licenceCardLoadingConfig}
          shimmerPlaceholderConfig={shimmerPlaceholderConfig}
        />
      </View>
    );
  };

  const renderLicencesListShimmering = () => {
    return _map(Array(8), (_, key) => renderLicenceCard(key));
  };

  const renderLicencesShimmering = () => {
    return (
      <>
        <Shimmer
          config={licencesListTitleConfig}
          shimmerPlaceholderConfig={shimmerPlaceholderConfig}
        />
        <Shimmer config={searchBarConfig} shimmerPlaceholderConfig={shimmerPlaceholderConfig} />
        {renderFilterBarShimmering()}
        {renderLicencesListShimmering()}
      </>
    );
  };
  return (
    <View style={styles.containerStyle} {...props}>
      {renderLicencesUsageShimmering()}
      {renderLicencesShimmering()}
    </View>
  );
}

export default LicencesLoading;
